//import $ from 'jquery';
// Load typeahead and bloodhound
import Bloodhound from 'corejs-typeahead';
import typeahead from 'corejs-typeahead';
import Handlebars from 'handlebars';

(function(){
	'use strict';
	if($('.smp-address-finder').length > 0){
		var dataUrl = $('.smp-address-finder').data('target');
		var timestamp = new Date().getTime();
		var addresses = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: dataUrl + '?query=%QUERY' + '&timestamp=' + timestamp,
				wildcard: '%QUERY',
				cache: false,
				transform: function(response) {
					return $.map(response, function (tag) {
						return {
							bin_list: tag.attributes.bin_list,
							next_collection_date: tag.attributes.next_collection_date,
							collection_day: tag.attributes.collection_day,
							address: tag.attributes.address,
							collection_message: tag.attributes.collection_message,
							collection_zone: tag.attributes.collection_zone,
							green_collection_zone: tag.attributes.green_collection_zone
						}
					});
				}
			}
		  });

		$('.smp-address-finder .typeahead').typeahead({
			hint: true,
			minLength: 3,
			highlight: true,
			limit: 10
		}, {
			name: 'address-dataset',
			source: addresses,
			display: 'address',
			limit: 10
		});

		$('.smp-address-finder .typeahead').bind('typeahead:select', function(ev, suggestion) {
			
			var cycle01Bins = ["red","blue"]
			var cycle02Bins = ["red","yellow"];

			var cycle01Text = "Please put out your red bin and blue crate.";
			var cycle02Text = "Please put out your red and yellow bins.";


			var monthNames = [
				"January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"
			];
			suggestion.bin_list = JSON.parse(suggestion.bin_list);

			var dateData = new Date(suggestion.next_collection_date);
			var date = dateData.getDate();
			var pickupDay = dateData.getDay();
			var month = monthNames[dateData.getMonth()];
			var year = dateData.getFullYear();
			suggestion.friendlyDate = date + ' ' + month + ' ' + year;


			//
			//
			//
			//
			// TEMPORARY DATA FIX
			//
			//
			//
			//
/*
			var originalData = JSON.stringify(suggestion);
			var newData = "No changes";

			var today = new Date();
			
			suggestion.customDate = today;
			// alter date below to fake the day
			//var today = new Date('2021-07-04');

			var todayDay = today.getDay();
			var todayHour = today.getHours();
			var todayMinutes = today.getMinutes();

			// how many days to sunday?
			var daysToSunday = 7 - todayDay;
			// how many days to next pickup?
			var daysToNextPickup = datediff(today,dateData);
			console.log('daysToNextPickup ' + datediff(today,dateData));
			console.log('days to sunday ' + daysToSunday);

			// if the days to next pickup is greater than days to sunday,
			// then we are still in the same week as initial pickup.
			if(daysToNextPickup > daysToSunday){
				// now, if pickup is yet to come
				if(pickupDay >= todayDay){
					// then no change - this will be any weekday leading up to pickup
					// and the data "should" be correct
					console.log('same week, before pickup');
				} else {
					// here - we are still in the same week, before Sunday, but after initial pickup.
					// this is where the data shows incorrectly,
					// so switch it
					console.log('same week, after pickup');

					var binCounter = 0;
					
					for(var index = 0; index < suggestion.bin_list.length; index++){
						if(suggestion.bin_list[index] != 'green'){
							if(cycle01Bins.indexOf(suggestion.bin_list[index]) != -1){
								binCounter++;
							}
						}
					}

					if(binCounter == 2){
						console.log('cycle bins to ' + JSON.stringify(cycle02Bins));
						suggestion.bin_list = cycle02Bins;
						suggestion.collection_message = cycle02Text;
					} else {
						console.log('cycle bins to ' + JSON.stringify(cycle01Bins));
						suggestion.bin_list = cycle01Bins;
						suggestion.collection_message = cycle01Text;
					}
					newData = JSON.stringify(suggestion);
				}
			} else {
				// pickup is before sunday

				// if we're actually on Sunday, the data is still incorrect until it switches over
				// until about 8pm (TBC)
				// so if we're on Sunday
				if(daysToSunday === 7){
					// and if we're before 8pm
					// then switch the data over.
					if(todayHour < 20){
						if(JSON.stringify(suggestion.bin_list) == JSON.stringify(cycle01Bins)){
							console.log('cycle bins to ' + JSON.stringify(cycle02Bins));
							suggestion.bin_list = cycle02Bins;
							suggestion.collection_message = cycle02Text;
						} else {
							console.log('cycle bins to ' + JSON.stringify(cycle01Bins));
							suggestion.bin_list = cycle01Bins;
							suggestion.collection_message = cycle01Text;
						}
						newData = JSON.stringify(suggestion);
					} else {
						console.log('no change');
					}
				} else {
					console.log('no change');
				}
			}
			suggestion.originalData = originalData;
			suggestion.newData = newData;

			//
			//
			//
			//
			// END TEMPORARY DATA FIX
			//
			//
			//
			//
			*/
			loadResults(suggestion);
		});

		
		var datediff = function(first, second) {
			// Take the difference between the dates and divide by milliseconds per day.
			// Round to nearest whole number to deal with DST.
			return Math.round((second-first)/(1000*60*60*24));
		}
		
		

		var loadResults = function(suggestion){
			
			var source = document.getElementById('address-finder-template').innerHTML;
			var template = Handlebars.compile(source);
			var context = suggestion;
			var html = template(context);
			$('#address-finder-content').html(html);
		};
	}
	

	Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
		return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
	});

}());
